<template>
  <div class="overflow-x-auto">
    <table
      class="table table-xs md:table-sm xl:table-md"
      v-if="industries.length"
    >
      <thead>
        <tr>
          <th>#</th>
          <th>{{ __("Title") }}</th>
          <th class="hidden xl:block">{{ __("Description") }}</th>
          <th>{{ __("User") }}</th>
          <th>{{ __("Created At") }}</th>
          <th>{{ __("Action") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in industries">
          <td>{{ meta.per_page * (meta.current_page - 1) + index + 1 }}</td>
          <td>{{ item.title }}</td>
          <td class="hidden xl:block">{{ item.description || "---" }}</td>
          <td>{{ item.user || "---" }}</td>
          <td>{{ item.created_at }}</td>
          <td>
            <router-link
              :to="{ name: 'user.industry.show', params: { id: item.id } }"
              class="btn btn-outline btn-primary btn-sm"
            >
              {{ __("Show") }}
            </router-link>
            <router-link
              :to="{ name: 'user.industry.edit', params: { id: item.id } }"
              :class="{ 'btn-disabled': !can('setting.edit') }"
              class="btn btn-outline btn-info btn-sm mx-2"
            >
              {{ __("Edit") }}
            </router-link>
            <label
              @click="setItem(item)"
              for="delete-modal"
              :class="{ 'btn-disabled': !can('setting.delete') }"
              class="btn btn-outline btn-error btn-sm"
            >
              {{ __("Delete") }}
            </label>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="col-span-12 flex flex-col items-center mt-9" v-else>
      <NotFound />
    </div>
  </div>
</template>
<script setup>
const {
  meta,
} = useDashboard();
defineProps(["industries"]);
const emit = defineEmits(["setItem"]);
const setItem = (item) => emit("setItem", item);
</script>